module.exports = __webpack_public_path__ + "img/online-ps.51583606.png";